var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repair"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/etc/logo.png")}}),_c('strong',[_vm._v("잘못된 경로로 접근 되었습니다.")]),_c('p',[_vm._v("메인 페이지로 이동하셔서 로그인 해 주세요.")]),_c('router-link',{attrs:{"to":"/main"}},[_vm._v("메인 페이지로 가기")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }